import React from 'react';

import { useTranslation } from 'libs/i18n';
import { Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

import { HeaderStyled, CloseButtonStyled } from './styles';

type NotificationsHeaderProps = {
  onClosePopover: () => void;
};

export const NotificationsHeader = ({
  onClosePopover,
}: NotificationsHeaderProps) => {
  const { t } = useTranslation();

  return (
    <HeaderStyled
      alignItems="center"
      direction="row"
      justifyContent="space-between"
    >
      <Typography lineHeight="130%" variant="subtitle">
        {t('components.dialogNotifications.title')}
      </Typography>
      <CloseButtonStyled onClick={onClosePopover}>
        <Icon.Close size={16} />
      </CloseButtonStyled>
    </HeaderStyled>
  );
};
